import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import {
  resetSelectedProspectData,
  resetSelectedProspectId,
  setSelectedProspectId,
} from '../../../sequence/sequence-slice';
import {
  resetAssignCallOutcomeRequest,
  resetCallLogsFilters,
  resetCreateCallLogsNoteRequest,
  resetUpdateCallLogsNoteRequest,
  resetDeleteCallLogRequest,
  resetGetCallLogsProspectProfileSectionRequest,
  resetMarkUnseenMissedCallCountRequest,
  setActiveCallLogsTab,
  setCallLogsFilters,
  setShowDialer,
  setSingleCallDetails,
} from '../../dialer-slice';
import {
  listAllCallLogsRequest,
  listMissedCallsRequest,
  listIncomingVoicemailsRequest,
  deleteCallLogRequest,
  markUnseenMissedCallCountRequest,
  markCallAsSeenRequest,
  callLogsListCountsRequest,
  assignCallOutcomeRequest,
  getCallLogsProspectProfileSectionRequest,
} from '../../extra-actions';
import { addPhoneNumberRequest } from '../../../settings/components/do-not-call/extra-actions';
import { resetAddPhoneNumberRequest } from '../../../settings/components/do-not-call/do-not-call-slice';
import CallLogs from './call-logs';
import { listAllCallLogsPayload } from '../../types';
import { CallLogsFiltersState } from './components/call-logs-filters/type';
import { CallLog } from '../../types/call-logs';
import { AddPhoneNumberPayload } from '../../../settings/types/do-not-call-list';
import { setProspectToNavigateFromModal } from '../../../prospect/prospect-slice';
import dialer from '../..';

const mapStateToProps = (state: RootState) => ({
  callLogsList: state.dialer.callLogsList,
  listAllCallLogsRequestStatus: state.dialer.listAllCallLogsRequest.status,
  listMissedCallsRequestStatus: state.dialer.listMissedCallsRequest?.status,
  listIncomingVoicemailsRequestStatus:
    state.dialer.listIncomingVoicemailsRequest?.status,
  showDialer: state?.dialer?.showDialer,
  currentCallManagementState: state?.dialer?.currentCallManagementState,
  role: state?.home?.role,
  missedCallCount: state?.dialer?.missedCallCount,
  deleteCallLogRequestStatus: state?.dialer?.deleteCallLogRequest,
  markCallAsSeenRequestStatus: state?.dialer?.markCallAsSeenRequest.status,
  activeCallLogsTab: state?.dialer?.activeCallLogsTab,
  callLogsFilters: state?.dialer?.callLogsFilters,
  userTimezone: state?.home?.timeZone,
  callLogsListCountsResponse: state?.dialer?.callLogsListCountsResponse,
  assignCallOutcomeRequestStatus: state?.dialer?.assignCallOutcomeRequest,

  selectedProspectId: state.sequence.selectedProspectId,
  selectedProspectData: state.sequence.selectedProspectData,
  selectedProspectSequences: state.sequence.selectedProspectSequences,
  getSingleProspectDetailsStatus:
    state.sequence.getSingleProspectDetailsRequest.status,
  getSingleProspectSequencesDetailsStatus:
    state.sequence.getSingleProspectSequencesDetailsRequest.status,
  getCallLogsProspectProfileSectionRequestStatus:
    state?.dialer?.getCallLogsProspectProfileSectionRequest.status,
  selectedCallbackProspect: state?.dialer?.selectedCallbackProspect,
  createCallLogsNoteRequestStatus:
    state?.dialer?.createCallLogsNoteRequest?.status,
  updateCallLogsNoteRequestStatus:
    state?.dialer?.updateCallLogsNoteRequest?.status,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  createTaskRequestMessage: state.tasks.createTaskRequest.message,
  getPostLoadMetaResponse: state?.home?.getPostLoadMetaResponse,
  getCallLogsProspectProfileSectionResponse:
    state?.dialer?.getCallLogsProspectProfileSectionResponse,
  addPhoneNumberRequestStatus:
    state.callDoNotContact.addPhoneNumberRequest.status,
  myPhoneNumbersList: state?.dialer?.myPhoneNumbersList,
  dialerSubscription: state?.home?.dialerSubscription,
  isDemoAccount: state?.home?.isDemoAccount,
  isDialerPlanPurchasedPreviously: state?.home?.isDialerPlanPurchasedPreviously,
});

const mapDispatchToProps = {
  sendListAllCallLogsRequest: (payload: listAllCallLogsPayload) =>
    listAllCallLogsRequest(payload),
  listMissedCallsRequest: (payload: listAllCallLogsPayload) =>
    listMissedCallsRequest(payload),
  listIncomingVoicemailsRequest: (payload: listAllCallLogsPayload) =>
    listIncomingVoicemailsRequest(payload),
  setShowDialer: (show: boolean) => setShowDialer(show),
  setActiveCallLogsTab: (tab: string) => setActiveCallLogsTab(tab),
  sendDeleteCallLogRequest: (callId: number) => deleteCallLogRequest(callId),
  sendMarkUnseenMissedCallCountRequest: () =>
    markUnseenMissedCallCountRequest(),
  resetMarkUnseenMissedCallCountRequest: () =>
    resetMarkUnseenMissedCallCountRequest(),
  resetDeleteCallLogRequest: () => resetDeleteCallLogRequest(),
  sendMarkCallAsSeenRequest: (callIds: number[]) =>
    markCallAsSeenRequest(callIds),
  setCallLogsFilters: (filters: CallLogsFiltersState) =>
    setCallLogsFilters(filters),
  resetCallLogsFilters: () => resetCallLogsFilters(),
  callLogsListCountsRequest: () => callLogsListCountsRequest({}),
  sendAssignCallOutcomeRequest: (outcomeId: number, dialerCallLogId: number) =>
    assignCallOutcomeRequest({ outcomeId, dialerCallLogId }),
  resetAssignCallOutcomeRequest: () => resetAssignCallOutcomeRequest(),

  setSelectedProspectId: (id: number) => setSelectedProspectId(id),
  resetSelectedProspectId: () => resetSelectedProspectId(),
  resetSelectedProspectData: () => resetSelectedProspectData(),
  sendGetCallLogsProspectProfileSectionRequest: (callId: number) =>
    getCallLogsProspectProfileSectionRequest(callId),
  resetGetCallLogsProspectProfileSectionRequest: () =>
    resetGetCallLogsProspectProfileSectionRequest(),
  setSingleCallDetails: (call: CallLog) => setSingleCallDetails(call),
  resetCreateCallLogsNoteRequest: () => resetCreateCallLogsNoteRequest(),
  resetUpdateCallLogsNoteRequest: () => resetUpdateCallLogsNoteRequest(),
  sendAddPhoneNumberRequest: (payload: AddPhoneNumberPayload) =>
    addPhoneNumberRequest(payload),
  resetAddPhoneNumberRequest: () => resetAddPhoneNumberRequest(),
  /** Clears CRM list/kanban modal-nav context so drawer arrows stay expand/collapse-only (see prospect slice). */
  clearProspectModalNavigationContext: () =>
    setProspectToNavigateFromModal({ ids: [], columnName: '' }),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(CallLogs);
